import React, { Component } from 'react'

export class Footer extends Component {
  

  render() {
    return (
      <footer>
        <div className="container">

          <div className="footerTop">
            <h2 className="heading-2">FOLLOW ME</h2>

            <ul className="footerIcons">
              <li>
                <a 
                  href="https://github.com/Jimmyelvis"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src="assets/img/icon-github.png" alt="" />
                </a>
              </li>

              <li>
                <a 
                  href="https://www.linkedin.com/in/marcusmckinstry/"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <img src="assets/img/icon-linked.png" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footerBottom">
            <p>
              COPYRIGHT <span className="copyright">WWW.MLMONTHEWEB.COM</span>
            </p>
        </div>

      </footer>
    );
  }
}

export default Footer
